/*
* Tracks changes to a header model by comparing the original data against form data
* @param {Object} form
* @param {Object} original
* @return {Object} deltas
*/
export function trackHeaderChanges (form, original) {
  let deltas = {}
  for (let i in form) {
    if (!form.hasOwnProperty(i)) continue
    let changeFound
    if (form && form[i] && form[i].hasOwnProperty('value')) {
      changeFound = compare(form[i].value, original[i], i)
    } else {
      changeFound = compare(form[i], original[i], i)
    }
    if (changeFound !== null) deltas[i] = changeFound
  }
  return deltas
}

/*
* Tracks changes to distribution line models by comparing the original data against form data
* @param {Object} form
* @param {Object} original
* @return {Object} deltas
*/
export function trackDistributionChanges (newLines, originalLines) {
  const checkForm = (form) => {
    let deltas = {}
    const original = originalLines.find(v => {
      return v.form ? v.form.id === form.id : v.id === form.id
      // const idType = (form) => form.hasOwnProperty('original_line_id') ? 'original_line_id' : 'id'
      // return v.form ? (v.form[idType(v.form)] === form[idType(form)]) : (v[idType(v)] === form[idType(form)])
    })
    const getVal = (val) => val && val.hasOwnProperty('value') ? val.value : val
    const excludedProps = ['line', 'line_number', 'id', 'original_line_id']
    for (let i in form) {
      if (!(original && original.form) || !form.hasOwnProperty(i) || excludedProps.includes(i)) {
        continue
      }
      let changeFound = compare(getVal(form[i]), getVal(original.form[i]))
      if (changeFound || (getVal(original.form[i]) && changeFound === '')) {
        deltas[i] = changeFound
      }
    }
    if (Object.keys(deltas).length) {
      return deltas
    }
    return null
  }
  let ret = {} // Holds newly created lines
  newLines.forEach(line => {
    if (!line.hasOwnProperty('form')) {
      return
    }
    if (!line.form.id) {                                               // A newly created line won't have an 'id' property
      if (ret.hasOwnProperty('new') && Array.isArray(ret.new)) {    // If ret already has a 'new' property and ret.new is an array
        ret.new.push(line)                                             // Push the newly created line into ret.new
      } else {                                                          // If not
        ret['new'] = []                                               // Add a 'new' property to ret and assign it an empty array
        ret.new.push(line)                                            // Add the first new line here
      }
    } else if (line.form.id && line.deleteLine) {
      if (ret.hasOwnProperty('delete') && Array.isArray(ret.delete)) {
        ret.delete.push(line)
      } else {
        ret['delete'] = []
        ret.delete.push(line)
      }
    } else {
      const changesMade = checkForm(line.form)
      if (changesMade) {
        ret[line.form.id] = changesMade
      }
    }
  })
  return ret
}

/*
* Test whether two form fields contain equal values. Returns new value if not
* @param newVal
* @param originalVal
* @return newVal
*/
function compare (newVal, originalVal, fieldName = '') {
  if (typeof fieldName === 'string' && fieldName.endsWith('_decimal')) {
    const isEmpty = v => v === '' || v === null || v === undefined
    const n1 = isEmpty(newVal) ? 0 : Number(newVal)
    const n2 = isEmpty(originalVal) ? 0 : Number(originalVal)
    if (!isNaN(n1) && !isNaN(n2)) {
      return n1 === n2 ? null : newVal
    }
  }
  if (newVal === '' && !originalVal) {
    newVal = null
    originalVal = null
  }
  if (!(`${newVal}` === `${originalVal}`)) return newVal
  return null
}



// WEBPACK FOOTER //
// ./src/utils/helpers/DataEntryViews/TrackChanges.js